import React, { useContext, useRef, useState } from "react";
import pic from "../../images/academy.jpg";
import { Link } from "react-router-dom";
import { toFarsiNumber } from "../../helper/helper";
import CircleLoading from "../shared/CircleLoading";
import { favouriteListContext } from "../../contexts/FavouriteContext";
import { postData } from "../../services/API";
import { getItemStorage } from "../../Localstorage/useLocalStorage";
import { Toast } from "primereact/toast";

const NewAcademyCard = ({ data, click, setCourseInfo, courseInfo }) => {
  const [loading, setLoading] = useState(false);
  const { favouriteList, setFavouriteList } = useContext(favouriteListContext);
  const [addedFav, setAddedFav] = useState(false);
  const token = getItemStorage("token");
  const failLike = useRef(null);

  // add or remove from favourite list
  const addFavourite = () => {
    if (token) {
      const favorite = favouriteList.filter((f) => f.id === data.id);

      // if product was in favorite list delete it otherwise add it
      if (favorite.length > 0) {
        setAddedFav(false);

        postData("/user/remove-from-favorite", { lesson_id: data.id })
          .then((res) => {
            const newData = favouriteList.filter((f) => f.id !== data.id);
            setAddedFav(false);

            setFavouriteList(newData);
          })
          .catch((err) => {
            setAddedFav(true);
          });
      } else {
        // add product to favourite list
        setAddedFav(true);

        postData("/user/add-to-favorite", { lesson_id: data.id })
          .then((res) => {
            setFavouriteList((prev) => [...prev, data]);
            setAddedFav(true);
          })
          .catch((err) => {
            setAddedFav(false);

            if (err.response.data.message === "Unauthenticated.") {
              failLike.current.show({
                severity: "error",
                summary: "وارد حساب کاربری کاربری شوید",
                detail: "برای افزودن به علاقه مندی وارد شوید",
                life: 2000,
              });
            }
          });
      }
    } else {
      failLike.current.show({
        severity: "error",
        summary: "وارد حساب کاربری کاربری شوید",
        detail: "برای افزودن به علاقه مندی وارد شوید",
        life: 2000,
      });
    }
  };

  const setInfoHandler = () => {
    click && setCourseInfo(data);
  };

  return (
    <div onClick={setInfoHandler} className="w-full flex flex-col gap-2">
      <Toast ref={failLike} />

      <div className="relative group w-full">
        {addedFav ||
        favouriteList.filter((f) => f.id === data.id).length > 0 ? (
          <button
            onClick={addFavourite}
            className="py-2 px-2 rounded-lg absolute z-10 bg-red-600 transition-all duration-300 left-4 top-4 flex items-center gap-1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-4 h-4 fill-white transition-all duration-300"
            >
              <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
            </svg>
          </button>
        ) : (
          <button
            onClick={addFavourite}
            className="py-2 px-2 rounded-lg absolute z-10 bg-[#222] text-red-600 group hover:bg-red-600 hover:text-white transition-all duration-300 left-4 top-4 flex items-center gap-1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
              />
            </svg>

            {/* <span className="text-red-600 group-hover:text-white text-xs transition-all duration-300">
            علاقه مندی
          </span> */}
          </button>
        )}

        <Link className="w-full" to={`/courses/${data.slug}`}>
          {!loading && (
            <div className="w-full h-[305px] flex justify-center items-center">
              <CircleLoading />
            </div>
          )}

          <img
            src={`https://api.myunibest.ir/${data.image}`}
            className={`rounded-xl w-full !h-[230px] sm:!h-[318px] object-cover ${
              !loading && "!hidden"
            }`}
            alt={data.name}
            onLoad={() => setLoading(true)}
          />
        </Link>

        <Link
          to={`/courses/${data.slug}`}
          className="academy-card-overly opacity-0 transition-all duration-300 delay-300 group-hover:opacity-100 flex flex-col justify-end gap-3 p-3 pb-5 rounded-xl"
        >
          {data.creator?.name && (
            <div className="text-gray-200 flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-5 h-5"
              >
                <path
                  fill-rule="evenodd"
                  d="M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625Zm1.5 0v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5A.375.375 0 0 0 3 5.625Zm16.125-.375a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5A.375.375 0 0 0 21 7.125v-1.5a.375.375 0 0 0-.375-.375h-1.5ZM21 9.375A.375.375 0 0 0 20.625 9h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5ZM4.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5ZM3.375 15h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h1.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 4.875 9h-1.5A.375.375 0 0 0 3 9.375v1.5c0 .207.168.375.375.375Zm4.125 0a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Z"
                  clip-rule="evenodd"
                />
              </svg>

              <span className="text-sm">{data.creator.name}</span>
            </div>
          )}

          {data.year && (
            <div className="text-gray-200 flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-5 h-5"
              >
                <path d="M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
                <path
                  fill-rule="evenodd"
                  d="M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z"
                  clip-rule="evenodd"
                />
              </svg>

              <span className="text-sm">
                {toFarsiNumber(String(data.year))}
              </span>
            </div>
          )}

          <div className="text-gray-200 flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              className="fill-white w-5 h-5"
            >
              <path
                className="block"
                d="M14.216 3H6.26a3.26 3.26 0 0 0-3.26 3.26v7.957a3.26 3.26 0 0 0 3.26 3.26h7.955a3.26 3.26 0 0 0 3.26-3.26V6.262A3.26 3.26 0 0 0 14.216 3zM6.2 14.428a.9.9 0 0 1 0-1.8.9.9 0 0 1 .636 1.537.9.9 0 0 1-.637.263zm8.077 0h-5.31a.9.9 0 1 1 0-1.8h5.3a.9.9 0 1 1 0 1.8zm0-3.356H6.2a.9.9 0 0 1 0-1.8h8.076a.9.9 0 0 1 0 1.8zm0-3.222H6.2a.9.9 0 1 1 0-1.8h8.076a.9.9 0 1 1 0 1.8z"
              ></path>
            </svg>

            <span className="text-sm">
              {data.has_saudio
                ? "دوبله اختصاصی"
                : data.has_audio
                ? "دوبله فارسی"
                : data.has_sub
                ? "زیرنویس فارسی"
                : "زبان اصلی"}
            </span>
          </div>

          {data?.teachers?.length > 0 && (
            <div className="text-gray-200 flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-5 h-5"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.54 15h6.42l.5 1.5H8.29l.5-1.5Zm8.085-8.995a.75.75 0 1 0-.75-1.299 12.81 12.81 0 0 0-3.558 3.05L11.03 8.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l2.47-2.47 1.617 1.618a.75.75 0 0 0 1.146-.102 11.312 11.312 0 0 1 3.612-3.321Z"
                  clip-rule="evenodd"
                />
              </svg>

              <span className="text-sm">{data.teachers[0].teacher.name}</span>
            </div>
          )}
        </Link>
      </div>

      <Link
        to={`/courses/${data.slug}`}
        className="text-gray-200 px-3 line-clamp-1 text-center font-black text-sm md:text-lg"
      >
        {data.name}
      </Link>
    </div>
  );
};

export default NewAcademyCard;
